const TextBlocks = ({ template }) => {
  return (template || []).map((block, index) => <Element key={index} {...block} />);
};

const Element = ({ type, ...props }) => {
  switch (type) {
    case 'paragraph':
      return (
        <p className="mb-4">
          <TextBlocks template={props.children} />
        </p>
      );

    case 'list':
      return (
        <ul className="mb-4">
          <TextBlocks template={props.children} />
        </ul>
      );

    case 'list-item':
      return (
        <li>
          <span className="mr-3 ml-2 inline-block h-[8px] w-[8px] rounded bg-current lg:h-[10px] lg:w-[10px]" />
          <TextBlocks template={props.children} />
        </li>
      );

    case 'text':
      const className = props.bold ? 'font-medium' : '';

      return <span className={className}>{props.text}</span>;

    case 'link':
      return (
        <a href={props.url} target="_blank" rel="noopener noreferrer" className="underline">
          <TextBlocks template={props.children} />
        </a>
      );

    case 'heading':
      return (
        <div className="txt-lg mb-1 font-medium">
          <TextBlocks template={props.children} />
        </div>
      );

    default:
      return null;
  }
};
export default TextBlocks;
